

































import { Component, Vue, Prop } from 'vue-property-decorator'
import DefaultBackIcon from '@/assets/navBack/back_white@2x.png'
import { CommonModule } from '@/store/modules/common'
@Component
export default class extends Vue {
  @Prop({
    default: DefaultBackIcon,
    type: String
  })
  backIcon!: string
  @Prop({
    default: '#ffffff',
    type: String
  })
  backgroundColor!: string
  @Prop({
    default: '#000000',
    type: String
  })
  fontColor!: string
  @Prop({
    type: Function,
    default: () => {
      console.log('click left')
      window.history.back()
    }
  })
  goBack!: Function
  @Prop({
    default: '',
    type: String
  })
  propTitle!: string
  @Prop({
    default: false,
    type: Boolean
  })
  border!: boolean
  get title() {
    return this.propTitle ? this.propTitle : this.$route.meta?.title
  }
  isJiejiMall = !!CommonModule.IDFA2
  created() {
    //
  }
}
